import checkDeviceTypeHelper from "./check-device-type-helper";

class GeneralHelper {
  checkImageExist(url) {
    const img = new Image();
    img.src = url;

    return new Promise((resolve) => {
      if (img.complete) {
        resolve(true);
      }
  
      img.onload = () => {
        resolve(true);
      }

      img.onerror = () => {
        resolve(false);
      }
    });
  }

  canSpeechText(data, isDesktop) {
    return ((data.content.abstract.data || data.content.body.data) && isDesktop)
  }

  tinnyScreen(windowWidth) {
    return windowWidth < 800;
  }
  tinnysScreen(windowWidth) {
    return windowWidth >= 800 && windowWidth < 1000;
  }
  smallScreen(windowWidth) {
    return windowWidth >= 1000 && windowWidth < 1200;
  }
  smallsScreen(windowWidth) {
    return windowWidth >= 1200 && windowWidth < 1300;
  }
  mediumScreen(windowWidth) {
    return windowWidth >= 1300 && windowWidth < 1400;
  }
  largeScreen(windowWidth) {
    return windowWidth >= 1400 && windowWidth < 1700;
  }
  bigScreen(windowWidth) {
    return windowWidth >= 1700 && windowWidth < 1800;
  }
  hugeScreen(windowWidth) {
    return windowWidth >= 1800;
  }

  clearFilterFields(filter) {
    if (
      filter.characteristic.length &&
      filter.periodicity.length &&
      filter.country.length &&
      filter.topic.length &&
      filter.content.length &&
      filter.subject.length &&
      filter.users &&
      filter.fromDate &&
      filter.toDate &&
      filter.highlights &&
      filter.inLive &&
      filter.important &&
      filter.exclusive &&
      filter.attachment &&
      filter.video &&
      filter.podcast &&
      filter.audio &&
      filter.disclosureInvite &&
      filter.disclosureAnnouncement &&
      filter.relevant &&
      filter.searchQuery
    ) {
      return; 
    }

    filter.characteristic = [];
    filter.periodicity = [];
    filter.country = [];
    filter.topic = [];
    filter.content = [];
    filter.subject = [];
    filter.users = null;
    filter.fromDate = null;
    filter.toDate = null;
    filter.highlights = false;
    filter.inLive = false;
    filter.important = false;
    filter.exclusive = false;
    filter.selectFilterDate = null;
    filter.attachment = false;
    filter.video = false;
    filter.podcast = false;
    filter.audio = false;
    filter.disclosureInvite = false;
    filter.disclosureAnnouncement = false;
    filter.relevant = false;
    if (filter.searchQuery) {
      filter.searchQuery = "";
    }

    return filter;
  }
}

export default new GeneralHelper();
